export interface FAQItem {
  id: string;
  question: string;
  answer: string;
  categories: string[];
}

export const faqCategories = [
  { id: "all", label: "Todas" },
  { id: "geral", label: "Geral" },
  { id: "oficial", label: "Oficial" },
  { id: "mercado_imobiliario", label: "Mercado Imobiliário" },
  { id: "cidadao", label: "Cidadão" },
  { id: "reforma_tributaria", label: "Reforma Tributária" },
  { id: "impostos", label: "Impostos" },
  { id: "juridico_cartorios", label: "Jurídico e Cartórios" },
  { id: "consulta", label: "Consulta e Acesso" },
  { id: "implementacao", label: "Implementação" },
  { id: "integracao", label: "Integração" },
  { id: "regularizacao", label: "Regularização" },
  { id: "sinter", label: "SINTER" },
] as const;

export const faqItems: FAQItem[] = [
  {
    id: "1",
    question: "O que é o Cadastro Imobiliário Brasileiro (CIB)?",
    answer:
      "O Cadastro Imobiliário Brasileiro (CIB) faz parte do Sistema Nacional de Gestão de Informações Territoriais (Sinter). O cadastro agregará informações cadastrais de imóveis rurais e urbanas, públicos ou privados, inscritos nos respectivos cadastros de origem, como o Cadastro Nacional de Imóveis Rurais (CNIR), administrado pelo Incra, e o cadastro de imóveis urbanos administrados pelas prefeituras municipais.",
    categories: ["oficial", "geral"],
  },
  {
    id: "2",
    question: "Qual o objetivo do CIB?",
    answer:
      "O objetivo é criar um cadastro com um código identificador único (código CIB), válido em todo território nacional, para cada unidade imobiliária georreferenciada (área e posição geográfica definida no mapa).",
    categories: ["oficial", "geral"],
  },
  {
    id: "4",
    question: "Precisa pagar alguma coisa?",
    answer: "Não. A inscrição no CIB não terá custo para o cidadão.",
    categories: ["oficial", "cidadao"],
  },
  {
    id: "5",
    question: "O que a sociedade ganha com a instituição do CIB?",
    answer:
      "Todos os imóveis que receberão código CIB necessariamente terão dados georreferenciados, ou seja, a sociedade terá acesso a informações confiáveis sobre os imóveis urbanos e rurais, inclusive com a localização geográficas (no mapa), observadas as regras de proteção de dados pessoais e de sigilo previstas em lei.",
    categories: ["oficial", "geral"],
  },
  {
    id: "6",
    question: "O CIB substituirá os cartórios?",
    answer:
      "Não. Cada instituição continuará a exercer suas atribuições legais. O CIB disponibilizará dados de bens imóveis para agregar às informações jurídicas dos cartórios, caso estejam disponíveis. A elaboração de escritura, registro de imóveis e emissão de certidões continuarão a ser realizadas pelos cartórios. Os cartórios poderão utilizar o CIB como identificador único para dar mais segurança em relação às operações que envolvam a localização física do imóvel.",
    categories: ["oficial", "geral"],
  },
  {
    id: "7",
    question:
      "O cadastro dos imóveis urbanos e rurais vai passar a ser feito pelo CIB?",
    answer:
      "Não. A elaboração, manutenção e gestão dos cadastros cabe às entidades designadas por lei, como por exemplo, o Incra, no caso dos imóveis rurais, e às prefeituras em relação aos imóveis urbanos.",
    categories: ["oficial", "integracao"],
  },
  {
    id: "8",
    question:
      "O código CIB substituirá o número da inscrição no cadastro imobiliário dos Municípios ou o código Incra?",
    answer:
      "Não. O código CIB acompanhará o ciclo de vida do imóvel sem interferir nem retirar a competência dos gestores dos cadastros originários.",
    categories: ["oficial", "integracao"],
  },
  {
    id: "9",
    question: "Que tipo de integração o CIB permitirá?",
    answer:
      "O CIB possibilitará relacionar as informações jurídicas dos imóveis com as informações físicas, geográficas, econômicas, ambientais e fiscais disponíveis nos Cadastros Territoriais Multifinalitários urbanos e no Cadastro Nacional de Imóveis Rurais (CNIR).",
    categories: ["oficial", "integracao"],
  },
  {
    id: "10",
    question: "Que tecnologias de georreferenciamento serão associadas ao CIB?",
    answer:
      "As opções tecnológicas escalas de precisão utilizadas na geolocalização dos imóveis são de livre escolha das entidades gestoras dos cadastros de origem. Cabe ao Sinter apenas desenvolver protocolos de troca e integração do CIB com os cadastros de origem.",
    categories: ["oficial", "integracao"],
  },
  {
    id: "11",
    question: "O que é o SINTER e qual sua relação com o CIB?",
    answer:
      "O Sistema Nacional de Gestão de Informações Territoriais (SINTER) é uma ferramenta de gestão pública que integra, em um banco de dados espaciais, o fluxo dinâmico de dados jurídicos (cartórios) com dados fiscais, cadastrais e geoespaciais de imóveis urbanos (prefeituras) e rurais (Incra). O CIB é o banco de dados de imóveis georreferenciados que faz parte do SINTER, sendo o identificador único nacional (o 'CPF dos imóveis') gerado a partir da integração dos cadastros de origem com o sistema.",
    categories: ["sinter", "integracao"],
  },
  {
    id: "12",
    question: "Qual é o formato do código CIB?",
    answer:
      "O código CIB é um identificador alfanumérico com dígito verificador, normalmente apresentado com separador (ex.: 'AAAAAAA-D'). Ele é gerado automaticamente a partir da integração dos cadastros de origem e serve como identificador único nacional para cada unidade imobiliária georreferenciada.",
    categories: ["geral", "sinter"],
  },
  {
    id: "13",
    question:
      "Quem administra e mantém o Cadastro Imobiliário Brasileiro (CIB)?",
    answer:
      "O CIB, assim como o Cadastro de Pessoas Físicas (CPF) e o Cadastro Nacional da Pessoa Jurídica (CNPJ), é administrado e mantido pela Receita Federal do Brasil.",
    categories: ["geral"],
  },
  {
    id: "15",
    question: "O CIB vai aumentar impostos como o IPTU ou ITR?",
    answer:
      "Não. O CIB é um cadastro e um identificador único, e sua instituição não tem como objetivo direto o aumento de impostos. No entanto, ao melhorar a gestão e a precisão das informações territoriais (georreferenciamento), ele contribui para a justiça fiscal e para a fiscalização, o que pode levar à correção de valores venais subestimados pelos municípios.",
    categories: ["impostos", "geral"],
  },
  {
    id: "16",
    question: "Como o CIB auxilia a Receita Federal na fiscalização?",
    answer:
      "O CIB, ao integrar dados de cartórios, prefeituras e Incra, permite à Receita Federal cruzar informações de forma mais eficiente. Isso é crucial para identificar, por exemplo, quem está de fato recebendo rendimentos de aluguéis, auxiliando no combate à sonegação fiscal e na melhoria da arrecadação.",
    categories: ["regularizacao"],
  },
  {
    id: "17",
    question:
      "Quais os benefícios do SINTER/CIB para os municípios, especialmente os pequenos?",
    answer:
      "O SINTER/CIB oferece aos municípios, sem custo, acesso a uma infraestrutura tecnológica em nuvem para implantação de uma base cadastral simplificada. Além disso, permite o acesso a dados de imóveis rurais, terras indígenas, transações imobiliárias e ao Cadastro Nacional de Obras (CNO) localizados no município, auxiliando no planejamento urbano e na gestão fiscal.",
    categories: ["sinter", "geral"],
  },
  {
    id: "18",
    question: "Qual o impacto do CIB na atuação do corretor de imóveis?",
    answer:
      "O CIB exige que o corretor de imóveis adote uma postura mais técnica e estratégica. O profissional deve confirmar a existência do CIB ao captar um imóvel, verificar a consistência dos dados cadastrais com a realidade física e orientar o cliente sobre o **Valor de Referência** fiscal, atuando como um agente de equilíbrio entre a padronização do fisco e a realidade do mercado.",
    categories: ["mercado_imobiliario", "geral"],
  },
  {
    id: "19",
    question:
      "O que é o 'Valor de Referência' do CIB e como ele afeta a compra e venda de imóveis?",
    answer:
      "O Valor de Referência é um valor de mercado presumido, previsto na legislação (ex: LC nº 214/2025), que será utilizado como parâmetro para o cálculo de novos tributos como o Imposto sobre Bens e Serviços (IBS) e a Contribuição sobre Bens e Serviços (CBS). Ele é gerado pelo sistema CIB e serve como base de cálculo fiscal, o que torna arriscado o subfaturamento de transações.",
    categories: ["reforma_tributaria", "impostos", "cidadao"],
  },
  {
    id: "21",
    question:
      "Como o CIB contribui para a segurança jurídica nas transações imobiliárias?",
    answer:
      "Ao integrar dados de diferentes fontes (cartórios, prefeituras, Incra) e associá-los a um georreferenciamento preciso, o CIB reduz o risco de fraudes, sobreposição de registros e disputas sobre a titularidade. Isso facilita a **due diligence** (verificação de conformidade) e aumenta a credibilidade dos negócios com imóveis.",
    categories: ["juridico_cartorios", "mercado_imobiliario"],
  },
  {
    id: "22",
    question:
      "O que acontece se o Valor de Referência do CIB for diferente do valor real de mercado do imóvel?",
    answer:
      "O contribuinte tem o direito de impugnar o Valor de Referência se ele não refletir a realidade do mercado. O corretor de imóveis ou avaliador pode auxiliar o proprietário na elaboração de um laudo técnico de avaliação, seguindo as normas da ABNT, para subsidiar a contestação do valor fiscal junto aos órgãos competentes.",
    categories: ["mercado_imobiliario", "impostos"],
  },
  {
    id: "23",
    question:
      "Qual a obrigação dos Cartórios de Notas e de Registro em relação ao CIB?",
    answer:
      "Os cartórios devem se integrar ao SINTER e adotar o código CIB. Além disso, a legislação (ex: IN RFB nº 2.275/2025) estabelece que eles devem compartilhar eletronicamente com o fisco todos os dados dos atos praticados, incluindo valores, para cruzamento com o Valor de Referência do CIB.",
    categories: ["juridico_cartorios", "oficial", "integracao"],
  },
  {
    id: "24",
    question:
      "Como o CIB auxilia advogados em processos de recuperação de crédito e execução?",
    answer:
      "O CIB, por ser um identificador único e georreferenciado, facilita a localização e a identificação unívoca de bens imóveis. Isso é fundamental para advogados em processos de penhora, execução e recuperação de crédito, pois minimiza erros cadastrais e agiliza a constrição judicial de bens.",
    categories: ["juridico_cartorios", "geral"],
  },
  {
    id: "25",
    question: "Por que o CIB é conhecido como 'CPF do imóvel'?",
    answer:
      "Porque, assim como o CPF é um identificador único e permanente de cada pessoa física no Brasil, o CIB funciona como um identificador exclusivo para cada imóvel. Diferente de nomenclaturas que variam de município para município ou entre cartórios, o CIB é padronizado nacionalmente, permitindo que um imóvel seja identificado de forma inequívoca em qualquer contexto.",
    categories: ["geral", "cidadao"],
  },
  {
    id: "26",
    question: "Qual é a diferença entre CIB e matrícula imobiliária?",
    answer:
      "A matrícula é o documento oficial de registro de um imóvel no Cartório de Registro de Imóveis, contendo informações jurídicas completas como proprietário, características físicas, histórico de transações e ônus reais. O CIB não substitui a matrícula, mas a complementa: é um código de identificação única, gerado automaticamente, que facilita a integração de dados entre diferentes órgãos públicos.",
    categories: ["juridico_cartorios", "integracao"],
  },
  {
    id: "28",
    question: "Quais são os módulos do SINTER?",
    answer:
      "O SINTER é organizado em quatro módulos principais: 1) Módulo Cartório: recebe informações dos Cartórios de Registro de Imóveis e de Títulos e Documentos; 2) Módulo Rural: agrega informações do INCRA e Receita Federal; 3) Módulo Urbano: recebe informações das prefeituras municipais sobre cadastros de IPTU; 4) Módulo CIB: funciona como o integrador universal, recebendo e processando o código de identificação única.",
    categories: ["sinter", "integracao"],
  },
  {
    id: "29",
    question: "Qual é o cronograma de implantação do CIB?",
    answer:
      "A implementação do CIB segue um cronograma gradual: 2025: Regulamentação oficial do CIB pela Receita Federal; 2026: Início das operações nas capitais dos Estados e Distrito Federal; 2027: Expansão do sistema para os demais municípios e regiões do país.",
    categories: ["implementacao", "oficial"],
  },
  {
    id: "30",
    question: "Como é gerado o CIB? Preciso solicitar?",
    answer:
      "Não. O CIB é gerado automaticamente pela administração pública, sem necessidade de ação do proprietário. Para imóveis urbanos, o código é gerado quando as prefeituras enviam suas informações cadastrais ao SINTER. Para imóveis rurais, o código é gerado ou vinculado quando os dados são atualizados no Cadastro Nacional de Imóveis Rurais (CNIR). No caso de imóveis públicos da União, os dados podem ser produzidos pela Secretaria de Coordenação e Governança do Patrimônio da União (SPU).",
    categories: ["cidadao", "geral"],
  },
  {
    id: "31",
    question: "Como funciona o CIB para imóveis urbanos?",
    answer:
      "Para imóveis urbanos, as prefeituras municipais enviam os dados cadastrais ao SINTER, que valida as informações e gera um CIB único para cada imóvel. O código é então disponibilizado no Portal da Receita Federal e incorporado pelos cartórios em seus sistemas. A maioria dos imóveis urbanos regulares já possui os dados necessários e receberão CIB automaticamente.",
    categories: ["geral", "implementacao"],
  },
  {
    id: "32",
    question: "Como funciona o CIB para imóveis rurais?",
    answer:
      "Para imóveis rurais, o CIB é gerenciado pelo INCRA e Receita Federal. O imóvel rural deve estar cadastrado no Sistema Nacional de Cadastro Rural (SNCR) do INCRA, obter o Certificado de Cadastro de Imóvel Rural (CCIR), e realizar a vinculação no CNIR. Se o imóvel já possui um Código Fiscal de Imóvel Rural (CAFIR), ele receberá um CIB vinculado.",
    categories: ["geral", "implementacao"],
  },
  {
    id: "33",
    question: "Qual é a diferença entre CCIR, CAFIR e CIB no contexto rural?",
    answer:
      "CCIR (Certificado de Cadastro de Imóvel Rural) é documento emitido pelo INCRA que comprova o cadastro. CAFIR (Cadastro Fiscal de Imóveis Rurais) é base de dados da Receita Federal para fins tributários (ITR). CIB (Cadastro Imobiliário Brasileiro) é código único nacional de identificação que facilita a integração de dados entre órgãos públicos.",
    categories: ["geral", "impostos"],
  },
  {
    id: "34",
    question: "Como consultar o CIB de um imóvel?",
    answer:
      "A consulta ao CIB tende a ser feita online. Para imóveis urbanos, procure no Portal/serviços da Receita Federal a opção de consulta de imóvel urbano (ou, quando disponível, portais integrados de estados e prefeituras). Para imóveis rurais, a consulta pode ocorrer em serviços vinculados ao CAFIR/CNIR (ex.: coletorcafir.receita.fazenda.gov.br, opção 'Consulta CAFIR'). Durante a fase de transição (2026-2027), nem todos os imóveis terão CIB consultável imediatamente.",
    categories: ["consulta", "cidadao"],
  },
  {
    id: "35",
    question: "Como o CIB afeta o cálculo do IPTU?",
    answer:
      "O CIB não altera diretamente as alíquotas, mas fornece dados mais precisos sobre características dos imóveis, o que pode levar as prefeituras a atualizar o 'Valor Venal de Referência'. Muitos municípios possuem valores venais desatualizados, e com o CIB essas defasagens são expostas, podendo resultar em aumentos de IPTU.",
    categories: ["impostos", "cidadao"],
  },
  {
    id: "36",
    question: "O que é 'Valor Venal de Referência' no CIB?",
    answer:
      "É uma estimativa de valor de mercado calculada e disponibilizada no SINTER para cada imóvel. Baseia-se em características físicas, localização, dados de mercado e informações geoespaciais. Será público e utilizado como subsídio para cálculos tributários, embora não substitua as metodologias tradicionais de IPTU ou ITBI.",
    categories: ["impostos", "geral"],
  },
  {
    id: "37",
    question:
      "Como o CIB afeta o ITBI (Imposto sobre Transmissão de Bens Imóveis)?",
    answer:
      "O CIB impacta significativamente o ITBI ao facilitar a comparação entre valor declarado e valor de referência, reduzir a subavaliação em contratos, permitir auditoria automática e aumentar a arrecadação em municípios onde essa prática era comum.",
    categories: ["impostos", "reforma_tributaria"],
  },
  {
    id: "38",
    question: "Qual será o impacto do CIB na Reforma Tributária (IBS e CBS)?",
    answer:
      "O CIB é componente-chave da Reforma Tributária. Operações com imóveis passarão a ser tributadas pelo IBS (0,1% inicial) e CBS (0,9% inicial) em 2026. O CIB fornecerá dados mais precisos sobre valor de imóveis, afetando a base de cálculo desses novos impostos.",
    categories: ["reforma_tributaria", "impostos"],
  },
  {
    id: "39",
    question: "O CIB viola a privacidade do proprietário?",
    answer:
      "O CIB em si não viola privacidade, mas segue princípios da LGPD. Os registros imobiliários funcionam com base na publicidade, mas informações do proprietário podem ter acesso restrito a terceiros. Dados sensíveis podem ter restrições especiais (vítimas de violência, autoridades).",
    categories: ["consulta", "cidadao"],
  },
  {
    id: "40",
    question: "Quem pode acessar dados do CIB?",
    answer:
      "Informações básicas do imóvel são públicas. Dados pessoais sensíveis podem ter acesso restrito conforme LGPD. Órgãos públicos têm acesso completo para fins administrativos. Partes envolvidas em transações podem acessar dados relevantes. Imóveis de vítimas de violência podem ter restrições especiais.",
    categories: ["consulta"],
  },
  {
    id: "41",
    question: "Qual é o impacto do CIB em imóveis sem matrícula?",
    answer:
      "Imóveis sem matrícula enfrentarão dificuldades significativas: impossibilidade de CIB, vedação de operações de venda/financiamento, e necessidade de regularização. Proprietários precisam abrir matrícula no Cartório de Registro de Imóveis local com documentação comprobatória.",
    categories: ["regularizacao", "juridico_cartorios"],
  },
  {
    id: "42",
    question: "O que proprietários com imóveis irregulares devem fazer?",
    answer:
      "Verificar status na prefeitura e cartório, regularizar junto à prefeitura (inscrição ou atualização cadastral), regularizar junto ao cartório (abertura de matrícula), e para imóveis rurais inscrever no SNCR/INCRA. Realizar regularização o mais breve possível antes da implementação plena.",
    categories: ["regularizacao", "cidadao"],
  },
  {
    id: "43",
    question: "Que informações o CIB contém ou integrará?",
    answer:
      "O CIB integra dados jurídicos (proprietário, ônus, histórico), físicos (localização, área, características), fiscais (IPTU, valor venal), ambientais (CAR para rurais) e geoespaciais (mapeamento preciso, infraestrutura).",
    categories: ["geral", "integracao"],
  },
  {
    id: "44",
    question: "Como funciona o CIB para imóveis públicos?",
    answer:
      "Imóveis federais são gerenciados pela SPU, estaduais pelos estados, e municipais pelos próprios municípios. O objetivo é permitir rastreamento completo do patrimônio público, facilitando gestão e fiscalização, com transparência e acesso para controle social.",
    categories: ["geral", "oficial"],
  },
  {
    id: "45",
    question: "Como o CIB se aplica a imóveis em regime de condomínio?",
    answer:
      "Cada unidade autônoma (apartamento) recebe seu próprio CIB. Áreas comuns podem ter identificadores específicos. A Lei nº 14.382/2022 simplificou procedimentos de registro de condomínios, com regime especial para incorporações e condomínios de lotes.",
    categories: ["juridico_cartorios", "geral"],
  },
  {
    id: "46",
    question: "Qual será o impacto do CIB para proprietários de imóvel único?",
    answer:
      "Impacto moderado: possível aumento de IPTU se valor venal estava desatualizado, maior segurança jurídica, facilitação de processos, dados mais visíveis (compensado pela segurança), e necessidade de regularizar cadastro se estiver desatualizado.",
    categories: ["cidadao", "geral"],
  },
  {
    id: "47",
    question:
      "Como o CIB afeta investidores e proprietários de múltiplos imóveis?",
    answer:
      "Impacto mais significativo: transparência total de todos os imóveis, maior capacidade de cobrança tributária, necessidade de revisar estratégias com novos impostos (IBS, CBS), regularização de valores subavaliados, e manutenção atualizada de informações.",
    categories: ["mercado_imobiliario", "impostos"],
  },
  {
    id: "48",
    question: "Como o CIB afeta corretores imobiliários?",
    answer:
      "Mudança significativa: acesso a informações mais precisas, redução de documentos necessários, informações do CIB reduzem incertezas, atenção a novos impostos sobre comissões, e necessidade de capacitação para operacionalizar mudanças.",
    categories: ["mercado_imobiliario", "geral"],
  },
  {
    id: "49",
    question: "Como o CIB afeta bancos e instituições financeiras?",
    answer:
      "Mudança benéfica: dados mais precisos sobre imóveis usados como garantia, redução de risco, agilização de financiamentos, facilitação de compliance regulatório, e possibilidade de novos produtos financeiros baseados em dados precisos.",
    categories: ["mercado_imobiliario", "geral"],
  },
  {
    id: "50",
    question: "O que muda em 2026 especificamente?",
    answer:
      "Implementação em capitais, início de IBS e CBS com alíquotas simbólicas, SINTER operacional, adaptação de sistemas em centros urbanos, e primeiros impactos em IPTU e tributação para contribuintes em capitais.",
    categories: ["implementacao", "reforma_tributaria"],
  },
  {
    id: "51",
    question: "Como proprietários podem se preparar antes de 2026?",
    answer:
      "Verificar regularização, atualizar cadastro, pesquisar valor de mercado, reunir documentação, consultar profissionais, planejar tributação, e monitorar implementação do CIB na região.",
    categories: ["cidadao", "implementacao"],
  },
  {
    id: "52",
    question: "Como cartórios serão impactados pela implementação do CIB?",
    answer:
      "Adequar sistemas informatizados, integração com SINTER, padronização de procedimentos, capacitação de colaboradores, e manter dados sincronizados. Lei Complementar deu 12 meses para adequação.",
    categories: ["juridico_cartorios"],
  },
  {
    id: "53",
    question: "Como as prefeituras se adaptarão ao CIB?",
    answer:
      "Integração de sistemas de IPTU, migração/sincronização de cadastros, revisão de procedimentos, treinamento de servidores, orientação de contribuintes, e implementação de cálculos com IBS e CBS.",
    categories: ["implementacao"],
  },
  {
    id: "54",
    question: "Qual será o papel da Receita Federal no CIB?",
    answer:
      "Administração central, coordenação da integração de dados, geração de códigos, gerenciamento do SINTER, cálculo de valores de referência, fiscalização aprimorada, e disponibilização de portal de consulta.",
    categories: ["oficial", "regularizacao"],
  },
  {
    id: "55",
    question: "Qual é a base legal para o CIB?",
    answer:
      "Lei Complementar nº 214/2025 (institui CIB na Reforma Tributária), Instrução Normativa RFB nº 2.030/2021 (criação original), IN RFB nº 2.275/2025 (regulamentação), Decreto nº 11.208/2022 (institui SINTER), Lei nº 14.382/2022 (moderniza registros), Lei nº 6.015/1973 (Lei de Registros Públicos), Lei nº 13.709/2018 (LGPD).",
    categories: ["oficial", "juridico_cartorios"],
  },
  {
    id: "56",
    question: "O CIB é obrigatório para todas as operações imobiliárias?",
    answer:
      "Progressivamente será obrigatório para imóveis sujeitos a IBS e CBS. Expectativa de gradual obrigatoriedade para todos. Bancos provavelmente exigirão CIB em financiamentos. Proprietários sem CIB serão incentivados a regularizar.",
    categories: ["juridico_cartorios", "implementacao"],
  },
  {
    id: "57",
    question:
      "Como o CIB se diferencia de sistemas similares em outros países?",
    answer:
      "Escala continental, coordenação federalista múltipla, delegação a cartórios privados, tecnologia GIS moderna, combinação de fins múltiplos (registrais, fiscais, ambientais), e adaptação à realidade brasileira.",
    categories: ["geral", "integracao"],
  },
  {
    id: "58",
    question:
      "Qual é a diferença entre CIB e o antigo 'RGI' (Registro Geral de Imóveis)?",
    answer:
      "RGI é nome genérico do sistema local; CIB é código nacional único. RGI é nível local/estadual; CIB é nacional. RGI registra transações; CIB identifica e integra informações. São complementares, não substitutos.",
    categories: ["juridico_cartorios", "integracao"],
  },
  {
    id: "59",
    question: "Quais são os principais desafios na implementação do CIB?",
    answer:
      "Integração técnica de sistemas legados, qualidade de dados desatualizados, harmonização de conflitos, treinamento em escala nacional, prazos ambiciosos, custos elevados para municípios menores, resistência à transparência, e padronização complexa.",
    categories: ["implementacao"],
  },
  {
    id: "60",
    question: "Quais são as limitações do CIB?",
    answer:
      "Informações desatualizadas se origem é imprecisa, lags temporais na sincronização, imóveis irregulares não captados, dados incompletos se fonte original não tem informação, valor de referência pode não refletir realidade, maior exposição de dados pessoais, e custos de regularização.",
    categories: ["geral", "implementacao"],
  },
  {
    id: "61",
    question:
      "Qual será o impacto do CIB em imóveis informais ou clandestinos?",
    answer:
      "Exposição de construções sem licença, pressão para regularização, oportunidade de regularização em massa, desafio gigantesco em grandes áreas informais, risco de pressão fiscal desigual em comunidades de baixa renda.",
    categories: ["regularizacao", "implementacao"],
  },
  {
    id: "62",
    question: "Como o CIB evoluirá nos próximos anos (2027+)?",
    answer:
      "Expansão nacional completa, maior integração com IA e análise de dados, novos usos para políticas públicas, análise sofisticada de mercado, possível uso de blockchain, desenvolvimento de APIs, e integração com dados de sustentabilidade.",
    categories: ["geral", "implementacao"],
  },
  {
    id: "63",
    question: "Se vou vender um imóvel em 2026, o que devo saber sobre CIB?",
    answer:
      "Verifique se seu imóvel tem CIB, regularize dados, antecipe possível aumento de ITBI, considere IBS/CBS na precificação, explique ao comprador, tenha documentação pronta, e trabalhe com profissional especializado.",
    categories: ["cidadao", "implementacao", "impostos"],
  },
  {
    id: "64",
    question: "Se vou comprar um imóvel em 2026, o que devo considerar?",
    answer:
      "Verificar CIB, pesquisar valor de referência, confirmar ausência de débitos, verificar averbações, calcular ITBI precisamente, considerar IBS/CBS, solicitar comprovante de CIB, e usar assessoria especializada.",
    categories: ["cidadao", "implementacao", "impostos"],
  },
  {
    id: "65",
    question: "O que fazer se meu imóvel não está no CIB em 2026?",
    answer:
      "Investigar causa, regularizar cadastro na prefeitura, abrir matrícula se necessário, registrar no CNIR (se rural), agir rapidamente, reunir documentação, e buscar auxílio profissional se necessário.",
    categories: ["regularizacao", "cidadao", "consulta"],
  },
  {
    id: "66",
    question: "Qual é o conselho mais importante para proprietários sobre CIB?",
    answer:
      "Atue cedo na regularização, verifique dados, prepare-se financeiramente para possíveis aumentos, busque orientação profissional, monitore implementação, não ignore as mudanças, e mantenha informações sempre atualizadas.",
    categories: ["cidadao", "implementacao"],
  },
  {
    id: "67",
    question: "Quais são as oportunidades que o CIB oferece?",
    answer:
      "Maior segurança jurídica, facilidade nos processos, inclusão de imóveis informais, transparência do patrimônio, melhor análise de mercado, base para políticas públicas, e inovação com startups imobiliárias.",
    categories: ["geral", "mercado_imobiliario"],
  },
  {
    id: "68",
    question: "Como o CIB afeta proprietários que alugam imóveis?",
    answer:
      "A Instrução Normativa RFB nº 2.275/2025 torna obrigatório o CIB para todos os proprietários de imóveis, especialmente aqueles que alugam. Os locadores devem atualizar seus dados cadastrais, sob pena de penalidades. A medida visa reduzir a informalidade no mercado de aluguéis e aumentar a segurança jurídica, facilitando a fiscalização tributária. A Receita Federal poderá cruzar informações de registros com declarações de imposto de renda, aumentando a formalização do setor.",
    categories: ["cidadao", "regularizacao", "mercado_imobiliario"],
  },
  {
    id: "69",
    question: "O CIB vai aumentar a fiscalização sobre declarações de Imposto de Renda?",
    answer:
      "Sim. O CIB permite que a Receita Federal integre informações de cartórios e prefeituras em uma base de dados nacional, facilitando a verificação de informações nas declarações de Imposto de Renda. Isso aumenta a fiscalização sobre o patrimônio dos contribuintes e permite identificar inconsistências entre valores declarados e dados cadastrais, especialmente em relação a rendimentos de aluguéis e transações imobiliárias.",
    categories: ["regularizacao", "impostos"],
  },
  {
    id: "70",
    question: "Quando o CIB começou a ser exigido por órgãos federais e cartórios?",
    answer:
      "O CIB começou a ser exigido por órgãos federais e cartórios em janeiro de 2026. A implementação é gradual, com a expectativa de que todos os cartórios adotem o sistema até dezembro de 2026. A medida visa padronizar os registros imobiliários e combater a informalidade no mercado.",
    categories: ["implementacao", "juridico_cartorios"],
  },
  {
    id: "71",
    question: "O que é o ITCMD e como o CIB pode afetá-lo?",
    answer:
      "O ITCMD (Imposto sobre Transmissão Causa Mortis e Doação) é um tributo estadual cobrado em heranças e doações. O CIB pode impactar o ITCMD ao fornecer dados mais precisos sobre o valor de mercado dos imóveis, aumentando a base de cálculo do imposto. A integração de dados pode levar a uma atualização mais rápida dos valores venais, resultando em custos mais altos para herdeiros e donatários, mesmo sem alteração nas alíquotas.",
    categories: ["impostos", "geral"],
  },
  {
    id: "72",
    question: "Como o CIB combate a sonegação fiscal?",
    answer:
      "O CIB combate a sonegação fiscal ao centralizar dados de propriedades em uma única base, facilitando a fiscalização e o cruzamento de informações. A integração de dados de cartórios, prefeituras e Incra permite identificar transações não declaradas, valores subfaturados e rendimentos de aluguéis omitidos. A fiscalização mais rigorosa dificulta a sonegação e promove maior justiça fiscal, embora não altere diretamente as alíquotas de impostos.",
    categories: ["regularizacao", "impostos"],
  },
  {
    id: "73",
    question: "Quais são as preocupações do setor imobiliário em relação ao CIB?",
    answer:
      "O setor imobiliário expressa preocupações sobre possível aumento indireto de impostos devido à atualização de valores venais, maior exposição de dados e aumento da carga tributária sobre transações. Há também preocupações sobre privacidade, proteção de dados e o risco de que a modernização se transforme em um instrumento de vigilância patrimonial. Apesar disso, reconhece-se que o CIB traz maior segurança jurídica e transparência.",
    categories: ["mercado_imobiliario", "geral"],
  },
  {
    id: "74",
    question: "Como o CIB promove transparência nas transações imobiliárias?",
    answer:
      "O CIB promove transparência ao centralizar informações sobre imóveis em uma base de dados nacional, integrando dados de cartórios, prefeituras e Incra. Isso facilita o acesso a informações confiáveis sobre propriedades, incluindo localização geográfica, características físicas e histórico de transações. A transparência reduz o risco de fraudes, aumenta a segurança jurídica e facilita a due diligence em negócios imobiliários.",
    categories: ["geral", "mercado_imobiliario"],
  },
  {
    id: "75",
    question: "Qual é a relação entre o CIB e a Reforma Tributária de 2027?",
    answer:
      "O CIB é parte integrante da Reforma Tributária que entrará em vigor em 2027. A reforma estabelece critérios claros para atividades imobiliárias e cria o sistema que unificará cadastros de imóveis. O CIB fornecerá dados precisos para o cálculo dos novos tributos (IBS e CBS), além de prever benefícios sociais como abatimentos em locações residenciais. A reforma também estabelece alíquotas reduzidas para o setor imobiliário.",
    categories: ["reforma_tributaria", "geral"],
  },
  {
    id: "76",
    question: "O CIB pode levar a desigualdades fiscais?",
    answer:
      "Existe preocupação de que a implementação do CIB, se não acompanhada de garantias adequadas, possa levar a desigualdades fiscais. A atualização automática de valores venais pode impactar desproporcionalmente comunidades de baixa renda e áreas informais. É fundamental que a modernização seja acompanhada de políticas que evitem pressão fiscal desigual e garantam que o sistema não se transforme em instrumento de vigilância patrimonial, mas sim em ferramenta de justiça fiscal.",
    categories: ["geral", "regularizacao"],
  },
  {
    id: "77",
    question: "Por que o CIB pode resultar em aumento da carga tributária mesmo sem alterar alíquotas?",
    answer:
      "Embora o CIB não altere diretamente as alíquotas de impostos, ele pode impactar a base de cálculo ao fornecer informações mais precisas sobre o valor de mercado dos imóveis. A integração de dados permite que transações informais sejam registradas de forma mais eficiente, e a atualização dos valores venais pode resultar em uma carga tributária maior para os proprietários. Isso ocorre porque muitos municípios possuem valores venais desatualizados, e o CIB expõe essas defasagens.",
    categories: ["impostos", "geral"],
  },
  {
    id: "78",
    question: "Quais penalidades podem ser aplicadas a proprietários que não atualizarem seus dados no CIB?",
    answer:
      "Com a nova regulamentação da Instrução Normativa RFB nº 2.275/2025, os proprietários, especialmente locadores, devem atualizar seus dados cadastrais sob pena de penalidades. Embora as penalidades específicas dependam da regulamentação de cada município e órgão, a não atualização pode resultar em multas, dificuldades em transações imobiliárias e problemas com a fiscalização tributária. É recomendável manter os dados sempre atualizados para evitar complicações.",
    categories: ["regularizacao", "cidadao"],
  },
  {
    id: "79",
    question: "Como o CIB afeta a classe média e pequenos investidores imobiliários?",
    answer:
      "A classe média e pequenos investidores podem ser significativamente impactados pelo CIB. A atualização dos valores venais pode resultar em aumentos de IPTU, especialmente em regiões onde os valores estavam defasados. Para investidores com múltiplos imóveis, haverá maior transparência e capacidade de fiscalização, exigindo revisão de estratégias com os novos impostos (IBS e CBS). No entanto, o CIB também traz benefícios como maior segurança jurídica e facilidade em processos de financiamento.",
    categories: ["cidadao", "mercado_imobiliario", "impostos"],
  },
  {
    id: "80",
    question: "Quando está prevista a implementação completa do CIB em todo o território nacional?",
    answer:
      "A implementação do CIB segue um cronograma gradual: em 2025 houve a regulamentação oficial pela Receita Federal; em 2026 iniciaram as operações nas capitais dos Estados e Distrito Federal, com expectativa de que todos os cartórios adotem o sistema até dezembro de 2026; e em 2027 está prevista a expansão completa do sistema para os demais municípios e regiões do país, coincidindo com a entrada em vigor da Reforma Tributária.",
    categories: ["implementacao", "oficial"],
  },
  {
    id: "81",
    question: "O CIB substitui os cadastros municipais de IPTU?",
    answer:
      "Não. O CIB não substitui os cadastros existentes nas prefeituras. Ele funciona como um identificador único nacional que complementa e integra os cadastros municipais de IPTU. As prefeituras continuam responsáveis pela elaboração, manutenção e gestão de seus cadastros imobiliários urbanos. O CIB apenas facilita a integração de dados entre diferentes órgãos e promove maior padronização nacional.",
    categories: ["integracao", "geral"],
  },
  {
    id: "82",
    question: "Como o CIB facilita o acesso a dados atualizados sobre imóveis?",
    answer:
      "O CIB centraliza informações sobre propriedades rurais e urbanas em uma base de dados nacional, integrando dados de cartórios, prefeituras e Incra. Isso facilita o acesso a informações atualizadas e confiáveis sobre imóveis, incluindo características físicas, localização geográfica, histórico de transações e situação fiscal. O sistema promove maior transparência e confiabilidade nas informações, beneficiando compradores, vendedores, instituições financeiras e órgãos públicos.",
    categories: ["consulta", "geral"],
  },
  {
    id: "83",
    question: "Quais são os benefícios sociais previstos na Reforma Tributária relacionados ao CIB?",
    answer:
      "A Reforma Tributária prevê benefícios sociais para minimizar o impacto sobre pequenos proprietários, incluindo abatimentos em locações residenciais e alíquotas reduzidas para o setor imobiliário. O objetivo é proteger a população de menor renda e garantir que a modernização do sistema tributário não resulte em aumento desproporcional da carga tributária para quem possui apenas um imóvel ou depende de aluguéis para moradia.",
    categories: ["reforma_tributaria", "cidadao"],
  },
  {
    id: "84",
    question: "Como o CIB pode impactar o mercado de aluguéis?",
    answer:
      "O CIB pode impactar significativamente o mercado de aluguéis ao aumentar a formalização do setor. A Receita Federal poderá cruzar informações de registros com declarações de imposto de renda, identificando rendimentos não declarados. Isso pode levar a um aumento nos custos para inquilinos, já que proprietários podem repassar a maior carga tributária. Por outro lado, a formalização traz maior segurança jurídica e transparência para ambas as partes, reduzindo conflitos e facilitando processos legais.",
    categories: ["mercado_imobiliario", "cidadao", "regularizacao"],
  },
  {
    id: "85",
    question: "Existe risco de o CIB se tornar um instrumento de vigilância patrimonial?",
    answer:
      "Há preocupações legítimas sobre privacidade e proteção de dados com a implementação do CIB. Embora o sistema prometa aumentar a transparência e facilitar o controle tributário, é fundamental que sua implementação seja acompanhada de garantias para proteger dados pessoais conforme a LGPD. O CIB deve funcionar como ferramenta de justiça fiscal e modernização da gestão fundiária, não como instrumento de vigilância patrimonial excessiva. O equilíbrio entre transparência fiscal e proteção de dados é essencial.",
    categories: ["consulta", "geral"],
  },
];
